import React from 'react';

import Inner from '../components/inner/Inner.tsx';

import I from '../types.ts';

import Menu from '../../menu/Menu.tsx';

const renderPage: I['renderPage'] = function ({ prop: url }) {
    return (
        <div className="publicLegalHeader__page">
            <div className="publicLegalHeader__pageInner">
                <Inner url={url} />
            </div>
            <div className="public__section _footer">
                <Menu isFooter={true} />
            </div>
        </div>
    );
};

export default renderPage;
